import { useSelector } from 'react-redux'
import { selectTranslations } from '../redux/translationSlice'

const useTranslation = () => {
  const { translations } = useSelector(selectTranslations)

  const t = (key) => {
    return translations[key] || key
  }

  return { t }
}

export default useTranslation
